import { render } from "./appsList.vue?vue&type=template&id=a9ba387e&scoped=true"
import script from "./appsList.vue?vue&type=script&lang=js"
export * from "./appsList.vue?vue&type=script&lang=js"

import "./appsList.vue?vue&type=style&index=0&id=a9ba387e&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ba387e"]])

export default __exports__